import { Grid, Typography } from "@mui/material";
import React from "react";
import { ICardInfo } from "./ICardInfo";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LanguageIcon from "@mui/icons-material/Language";

const CardInfo = ({
  branchTitle,
  storeTitle,
  branchAddress,
  customerFullName,
  customerMobileNumber,
  customerWalletAmount,
  expirationDate_Persian,
  confirmInvoiceDate_Persian,
  issuanceInvoiceDate_Persian,
  saleDate_Persian,
  saleType,
  saleTypeTitle,
  storeUrl,
}: ICardInfo) => {
  return (
    <>
      <Grid
        container
        xs={12}
        columns={{ xs: 4, sm: 8, md: 12 }}
        style={{
          justifyContent: "center",
          backgroundColor: "#F6F8F9",
          border: "1px solid #EDEFEF",
          minHeight: "fit-content",
          alignContent: "center",
          margin: "1vh auto 2vh",
          width: "100%",
        }}
        className="MainheaderTitleColor"
      >
        <Grid
          container
          xs={12}
          style={{
            width: "100%",
            margin: "2vh auto 2vh",
          }}
          className="MainheaderTitleColor"
        >
          {customerFullName ? (
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              lg={3}
              borderLeft={{
                lg: "1px solid #EDEFEF",
                md: "1px solid #EDEFEF",
                sm: "1px solid #EDEFEF",
              }}
              borderBottom={{ xs: "1px solid #c1c7cb", md: "none", sm: "none" }}
              paddingX={".5rem"}
              paddingY={{
                xs: "1rem",
                sm: "1rem",
                md: "1rem",
                lg: "0",
                xl: "0",
              }}
              className="grid-header"
            >
              <Typography
                textAlign={{ sm: "center", md: "justify", xs: "center" }}
                style={{ fontSize: "1.2rem" }}
              >
                نام متقاضی:{" "}
                <b style={{ fontWeight: "bold" }}>{customerFullName}</b>
              </Typography>
            </Grid>
          ) : null}
          {customerMobileNumber ? (
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              lg={3}
              borderLeft={{ lg: "1px solid #EDEFEF", md: "1px solid #EDEFEF" }}
              borderBottom={{ xs: "1px solid #c1c7cb", md: "none", sm: "none" }}
              paddingX={{ lg: ".5rem", md: "0" }}
              paddingY={{
                xs: "1rem",
                sm: "1rem",
                md: "1rem",
                lg: "0",
                xl: "0",
              }}
              className="grid-header"
            >
              <Typography textAlign={"center"} style={{ fontSize: "1.2rem" }}>
                شماره موبایل:{" "}
                <b style={{ fontWeight: "bold" }}>{customerMobileNumber}</b>
              </Typography>
            </Grid>
          ) : null}
          {customerWalletAmount ? (
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              lg={3}
              borderLeft={{
                lg: "1px solid #EDEFEF",
                md: "1px solid #EDEFEF",
                sm: "1px solid #EDEFEF",
              }}
              borderBottom={{ xs: "1px solid #c1c7cb", md: "none", sm: "none" }}
              paddingX={".5rem"}
              paddingY={{
                xs: "1rem",
                sm: "1rem",
                md: "1rem",
                lg: "0",
                xl: "0",
              }}
              className="grid-header"
            >
              <Typography textAlign={"center"} style={{ fontSize: "1.2rem" }}>
                مجموع اعتبار (ریال):{" "}
                <b style={{ fontWeight: "bold" }} className="mainColor-100">
                  {customerWalletAmount.toLocaleString()}
                </b>
              </Typography>
            </Grid>
          ) : null}
          {expirationDate_Persian ? (
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              lg={3}
              borderLeft={{
                lg: "1px solid #EDEFEF",
                md: "1px solid #EDEFEF",
                sm: "1px solid #EDEFEF",
              }}
              paddingX={".5rem"}
              paddingY={{
                xs: "1rem",
                sm: "1rem",
                md: "1rem",
                lg: "0",
                xl: "0",
              }}
              className="grid-header"
            >
              <Typography textAlign={"center"} style={{ fontSize: "1.2rem" }}>
                تاریخ انقضای فاکتور:{" "}
                <b style={{ fontWeight: "bold" }} className="errorColor">
                  {expirationDate_Persian}
                </b>
              </Typography>
            </Grid>
          ) : null}
          {saleDate_Persian ? (
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              lg={3}
              borderLeft={{
                lg: "1px solid #EDEFEF",
                md: "1px solid #EDEFEF",
                sm: "1px solid #EDEFEF",
              }}
              borderBottom={{ xs: "1px solid #c1c7cb", md: "none", sm: "none" }}
              paddingX={".5rem"}
              paddingY={{
                xs: "1rem",
                sm: "1rem",
                md: "1rem",
                lg: "0",
                xl: "0",
              }}
              className="grid-header"
            >
              <Typography
                textAlign={{ sm: "center", md: "justify", xs: "center" }}
                style={{ fontSize: "1.2rem" }}
              >
                تاریخ پرداخت:{" "}
                <b style={{ fontWeight: "bold" }}>{saleDate_Persian}</b>
              </Typography>
            </Grid>
          ) : null}
          {issuanceInvoiceDate_Persian ? (
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              lg={3}
              borderLeft={{ lg: "1px solid #EDEFEF", md: "1px solid #EDEFEF" }}
              borderBottom={{ xs: "1px solid #c1c7cb", md: "none", sm: "none" }}
              paddingX={{ lg: ".5rem", md: "0" }}
              paddingY={{
                xs: "1rem",
                sm: "1rem",
                md: "1rem",
                lg: "0",
                xl: "0",
              }}
              className="grid-header"
            >
              <Typography textAlign={"center"} style={{ fontSize: "1.2rem" }}>
                تاریخ بارگذاری فاکتور:{" "}
                <b style={{ fontWeight: "bold" }}>
                  {issuanceInvoiceDate_Persian}
                </b>
              </Typography>
            </Grid>
          ) : null}
          {confirmInvoiceDate_Persian ? (
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              lg={3}
              borderLeft={{
                lg: "1px solid #EDEFEF",
                md: "1px solid #EDEFEF",
                sm: "1px solid #EDEFEF",
              }}
              borderBottom={{ xs: "1px solid #c1c7cb", md: "none", sm: "none" }}
              paddingX={".5rem"}
              paddingY={{
                xs: "1rem",
                sm: "1rem",
                md: "1rem",
                lg: "0",
                xl: "0",
              }}
              className="grid-header"
            >
              <Typography textAlign={"center"} style={{ fontSize: "1.2rem" }}>
                تاریخ تایید فاکتور:{" "}
                <b style={{ fontWeight: "bold" }} className="mainColor-100">
                  {confirmInvoiceDate_Persian}
                </b>
              </Typography>
            </Grid>
          ) : null}
        </Grid>
        <Grid xs={12} container style={{ justifyContent: "center" }}>
          <hr
            style={{
              color: "blue",
              width: "95%",
              height: "10px",
              margin: "0px",
            }}
          />
        </Grid>
        <Grid xs={12} container>
          <Grid
            item
            xs={12}
            style={{
              placeItems: "center",
              width: "98%",
              minHeight: "fit-content",
              margin: "1vh 5px 2vh",
              backgroundColor: "#EDEFEF",
              height: "50px",
              alignContent: "center",
              border: "1px solid #EDEFEF",
              boxShadow:
                "0 0px 1px 0 rgba(0, 0, 0, 0), 0 1px 1px 0 rgba(0, 0, 0, 0.2)",
              borderRadius: "5px",
            }}
          >
            <Grid container xs={12} alignItems={"center"}>
              <Grid
                item
                xs={12}
                sm={12}
                md={2}
                style={{ fontSize: "16px" }}
                paddingRight={{ xs: "10px", lg: "55px" }}
              >
                {saleType === "Onsite" ? (
                  <>
                    <StorefrontIcon />
                    <span style={{ paddingRight: "5px" }}>{saleTypeTitle}</span>
                  </>
                ) : (
                  <>
                    <LanguageIcon />
                    <span style={{ paddingRight: "5px" }}>{saleTypeTitle}</span>
                  </>
                )}
              </Grid>
              <Grid item xs={12} sm={12} md={10}>
                <Typography
                  textAlign={{ sm: "center", md: "justify", xs: "center" }}
                  style={{ fontSize: "1.2rem" }}
                >
                  {saleType === "Onsite" ? (
                    <>
                      شعبه فروشنده:{" "}
                      <b
                        style={{ fontWeight: "bold" }}
                        className="mainColor-100"
                      >
                        {storeTitle} - {branchTitle} ({branchAddress})
                      </b>{" "}
                    </>
                  ) : (
                    <>
                      سایت فروشنده:{" "}
                      <b
                        style={{ fontWeight: "bold" }}
                        className="mainColor-100"
                      >
                        {storeTitle} - {branchTitle} ({storeUrl})
                      </b>
                    </>
                  )}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default CardInfo;
